document
  .querySelectorAll('[data-expandable-self-pay-cards-controller]')
  .forEach((controller) => {
    const expandableCards = controller.querySelectorAll(
      '[data-expandable-self-pay-card]',
    );
    const expandFirst = controller.dataset.expandFirst === 'true';

    expandableCards.forEach((card, index) => {
      const controls = card.querySelector('[data-expandable-card-activator]');
      const firstCard = index === 0;

      if (firstCard && expandFirst) {
        card.dataset.selfPayCardExpanded = 'true';
      }

      controls.addEventListener('click', (e) => {
        const isExpanded = card.dataset.selfPayCardExpanded === 'true';
        const expandableContent = card.querySelectorAll(
          '[data-self-pay-expandable-content]',
        );
        const button = card.querySelector('.self-pay-card__button');

        button.classList.toggle('reverse');

        switch (isExpanded) {
          case true:
            expandableContent.forEach((el) => el.classList.add('hide'));
            card.dataset.selfPayCardExpanded = 'false';
            break;
          case false:
            expandableContent.forEach((el) => el.classList.remove('hide'));
            card.dataset.selfPayCardExpanded = 'true';
            break;
        }
      });
    });
  });
